import MeetOurExperts from "../../components/info/meet-our-experts"

const MeetOurExpertsPage = () => (
    <MeetOurExperts />
)

export default MeetOurExpertsPage;